export default __webpack_public_path__ + "static/media/clone.bf5d9ce4.svg";